/**
 * Step content for the Coordinator Dashboard first-run walkthrough.
 * `target` selectors are `data-tour` attributes added to dashboard widgets.
 * Steps whose target isn't present (e.g. progress/assessment-card on an empty
 * dashboard) are dropped automatically by GuidedTour.filterPresentSteps.
 */
export const coordinatorTourSteps = [
  {
    target: 'body',
    placement: 'center',
    disableBeacon: true,
    title: 'Welcome to your Coordinator Dashboard',
    content: 'A quick 60-second tour of where everything lives. You can skip anytime.',
  },
  {
    target: '[data-tour="start-assessment"]',
    placement: 'bottom',
    disableBeacon: true,
    title: 'Start a new assessment',
    content:
      'Kick off a multi-persona assessment here. Your CEO, CISO, CFO, and others each answer the same 51 questions from their angle — the multi-viewpoint approach reveals blind spots no single person sees.',
  },
  {
    target: '[data-tour="how-it-works"]',
    placement: 'bottom',
    title: 'The full method, anytime',
    content:
      'Expand this guide whenever you want the end-to-end walkthrough: create a session, invite personas, review responses, analyze results, take action.',
  },
  {
    target: '[data-tour="progress"]',
    placement: 'top',
    title: 'Track completion',
    content:
      'Watch overall and per-persona progress here as responses roll in. Your Cyber Risk Signal and Big 6 scores refine as more perspectives arrive.',
  },
  {
    target: '[data-tour="assessment-card"]',
    placement: 'top',
    title: 'Your assessments',
    content:
      'Each assessment shows its status and whether it is bridged to PRISM for the technical deep-dive.',
  },
  {
    target: '[data-tour="inbox"]',
    placement: 'bottom',
    title: 'Inbox',
    content: 'Persona questions and notifications land here so nothing slips through.',
  },
  {
    target: '[data-tour="primary-nav"]',
    placement: 'top',
    title: 'Insights & Help',
    content:
      'Once results are in, Business Intelligence and the Risk Optimization Studio turn them into action — and the Help center has the full methodology.',
  },
  {
    target: 'body',
    placement: 'center',
    title: "You're all set",
    content: 'Replay this tour anytime with the “Take a tour” button next to How It Works.',
  },
];
